import AlignmentMap from './AlignmentMap';

export default AlignmentMap;
